import { env } from "@Config/env";
import { runtime } from "@Config/runtime";
import axios from "axios";
const getConfigEndpoint = ()=>`${runtime.gatewayUrl}/api/client-config/word`;
const isProduction = process.env.NODE_ENV === "production";
/**
 * Get auth config synchronously for development environment.
 * Returns null in production (use getAuthConfig for async fetch).
 */ export const getLocalConfig = ()=>{
    return {
        domain: env.AUTH_DOMAIN,
        clientId: env.AUTH_CLIENT_ID,
        redirect_uri: window.location.origin + env.AUTH_URL_PATH,
        audience: env.AUTH_AUDIENCE,
        applicationId: null,
        clientToken: null,
        site: null,
        service: null
    };
};
/**
 * Get auth config asynchronously.
 * In development, returns the config immediately.
 * In production, fetches the config from the API.
 */ export const getAuthConfig = async ()=>{
    if (!isProduction) {
        return getLocalConfig();
    }
    const { data } = await axios.get(getConfigEndpoint());
    return {
        domain: data.AUTH_DOMAIN,
        clientId: data.AUTH_CLIENT_ID,
        redirect_uri: window.location.origin + data.AUTH_URL_PATH,
        audience: data.AUTH_AUDIENCE,
        applicationId: data.DATADOG_RUM_APPLICATION_ID,
        clientToken: data.DATADOG_RUM_CLIENT_TOKEN,
        site: data.DATADOG_RUM_SITE,
        service: data.DATADOG_SERVICE_NAME
    };
};
